var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("方案模板"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 700
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      "label-col": {
        span: 3
      },
      rules: _vm.dataRule
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [item.item.length != 0 ? _c("a-form-model-item", {
      attrs: {
        label: item.name
      }
    }, _vm._l(item.item, function (item2) {
      return _c("a-checkbox", {
        key: item2.id,
        attrs: {
          disabled: true
        },
        model: {
          value: item2.selected,
          callback: function ($$v) {
            _vm.$set(item2, "selected", $$v);
          },
          expression: "item2.selected"
        }
      }, [_vm._v(_vm._s(item2.name))]);
    }), 1) : _vm._e()], 1);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };